import React from "react";
import NavbarHeader from "../Navbar";
import FooterBfsg from "../FooterBfsg";
import Luximg from "../../Image/B2B-Website-UI/Smashbox.jpg";
import SmasgboxLogo from "../../Image/B2B-Website-UI/Smashbox-logo.png";
import OwlCarousel from "react-owl-carousel";
import Container from "react-bootstrap/Container";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Product01 from "../../Image/Top-Products/Photo-Finish.png";
import Product02 from "../../Image/Top-Products/Champagne-Pop.png";
import Product03 from "../../Image/Top-Products/Cali-Contour-Palette.png";
import Product04 from "../../Image/Top-Products/halo.png";
import Product05 from "../../Image/Top-Products/Full-exposure.png";

const Smashbox = () => {
  const options = {
    loop: true,
    margin: 50,
    nav: true,
    dots: false,
    navText: [
      '<svg xmlns="http://www.w3.org/2000/svg" width="42" height="13" viewBox="0 0 42 13" fill="none">' +
        '<path d="M0.357289 6.71437L9.62174 12.273C10.155 12.593 10.8333 12.2089 10.8333 11.587L10.8333 1.41296C10.8333 0.79112 10.155 0.407029 9.62174 0.72696L0.357289 6.28563C0.195455 6.38273 0.195455 6.61727 0.357289 6.71437Z" fill="#7F7F7F"/>' +
        '<path d="M10.8333 6.5L41.1667 6.5" stroke="#7F7F7F" stroke-linecap="round" stroke-linejoin="round"/>' +
        "</svg>",
      '<svg xmlns="http://www.w3.org/2000/svg" width="43" height="13" viewBox="0 0 43 13" fill="none">' +
        '<path d="M41.8093 6.28563L32.5449 0.726957C32.0117 0.407025 31.3333 0.791116 31.3333 1.41295L31.3333 11.587C31.3333 12.2089 32.0117 12.593 32.5449 12.273L41.8093 6.71437C41.9712 6.61727 41.9712 6.38273 41.8093 6.28563Z" fill="#7F7F7F"/>' +
        '<path d="M31.3333 6.5L0.999975 6.5" stroke="#7F7F7F" stroke-linecap="round" stroke-linejoin="round"/>' +
        "</svg>",
    ],
    responsive: {
      0: {
        items: 1,
      },
      767: {
        items: 2,
      },
      1000: {
        items: 3,
      },
    },
  };
  return (
    <div>
      <NavbarHeader />
      <section>
        <div className="container">
          <div className="mt-5 mb-5"></div>
          <div className="row">
            <div className="col-xl-4 col-lg-4 col-md-12 col-sm-12 m-auto">
              <div className="BnadLogo w-100">
                <img className="img-fluid" src={Luximg} />
              </div>
            </div>
            <div className="col-xl-8 col-lg-8 col-md-12 col-sm-12 m-auto ">
              <div className="row">
                <div className="col-xl-7 col-lg-6 col-md-12 col-sm-12 borderRight">
                  <img className="img-fluid" src={SmasgboxLogo} />
                </div>
                <div className="col-xl-5 col-lg-6 col-md-12 col-sm-12 m-auto ">
                  <h1 className="titleWithLogo">
                    Creativity, community, and collaboration.
                  </h1>
                </div>
              </div>
              <div className="autoHeight" id="ScrollRight">
                <p className="seti">
                  Everyone has a story. Ours is original and authentic and sets
                  us apart from every other beauty brand. We're proud of our
                  story, and this is how we tell it: We live for lipstick. We
                  get excited about primers. (No, seriously, we do.) But mostly,
                  we love sharing our makeup secrets with you. Why? Because
                  creativity and collaboration are at the core of our DNA. We
                  are the only brand born out of a legendary photo studio —
                  Smashbox Studios in Los Angeles — where major photographers,
                  celebrities and makeup artists converge to create iconic
                  images every day. Studio-tested, shockingly high-performance.
                  Longwearing and skincaring. Artistry made easy. Hardworking
                  makeup that keeps up with you.
                </p>
              </div>
            </div>
          </div>

          <div className="TopProducts NewArriavalsList">
            <h3 className="mt-5">TOP PRODUCTS</h3>
            <OwlCarousel className="owl-theme" {...options}>
              <div class="item">
                <div>
                  <div className="ArriavalsInnerContent">
                    <h4>Photo Finish Primers</h4>
                    <p>ALLURE Best of Beauty 2022: Control & Primerizer+</p>

                    <a href="https://b2b.beautyfashionsales.com/">
                      Shop The Collection
                    </a>
                    <div className="fitContent">
                      <img src={Product01} />
                    </div>
                  </div>
                </div>
              </div>
              <div class="item">
                <div>
                  <div className="ArriavalsInnerContent">
                    <h4>Champagne Pop</h4>
                    <p>
                      (Powder highlighter) Sold out of 25k in 10 minutes at
                      launch ALLURE Reader's Choice 2020
                    </p>
                    <a href="https://b2b.beautyfashionsales.com/">
                      Shop The Collection
                    </a>
                    <div className="fitContent">
                      <img src={Product02} />
                    </div>
                  </div>
                </div>
              </div>
              <div class="item">
                <div>
                  <div className="ArriavalsInnerContent">
                    <h4>Cali Contour Palette</h4>
                    <p>
                      (Palette with sculpting powders, bronzers, highlighters,
                      and blush)
                    </p>
                    <a href="https://b2b.beautyfashionsales.com/">
                      Shop The Collection
                    </a>
                    <div className="fitContent">
                      <img src={Product03} />
                    </div>
                  </div>
                </div>
              </div>
              <div class="item">
                <div>
                  <div className="ArriavalsInnerContent">
                    <h4>Halo Healthy Glow Tinted Moisturizer</h4>
                    <p>(Tinted Moisturizer with SPF & a glowing finish)</p>
                    <a href="https://b2b.beautyfashionsales.com/">
                      Shop The Collection
                    </a>
                    <div className="fitContent">
                      <img src={Product04} />
                    </div>
                  </div>
                </div>
              </div>
              <div class="item">
                <div>
                  <div className="ArriavalsInnerContent">
                    <h4>Full Exposure Lash Volumizing Mascara</h4>
                    <p>(Volumizing mascara)</p>
                    <a href="https://b2b.beautyfashionsales.com/">
                      Shop The Collection
                    </a>
                    <div className="fitContent">
                      <img src={Product05} />
                    </div>
                  </div>
                </div>
              </div>
            </OwlCarousel>
          </div>
        </div>
      </section>
      <FooterBfsg />
    </div>
  );
};

export default Smashbox;
